import { useIsMobile, getResponsiveImageUrl } from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import './storeBanner.scss';
import { goToCustomUrl } from 'controls/utils';
import { CTAButton } from 'components/atoms/Button/Button';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

export default function StoreBanner({ data }) {
  const isMobile = useIsMobile();
  const storeData = data;

  return (
    <div className='storeContainer'>
      <div className='imgContainer'>
        <FallbackImage
          src={getResponsiveImageUrl(storeData.imageUrl, storeData.mobileImageUrl, isMobile)}
          fallbackSrc={storeData.imageUrl}
          alt={DOMPurify.sanitize(storeData.title, { ALLOWED_TAGS: [] })}
          fetchPriority='high'
        />
        <div className='imgOverlay' />
      </div>

      <div className='storeContainer_data' style={{ textAlign: storeData.alignment, alignItems: storeData.alignment }}>
        <div className='storeContainer_title proxima-nova-bold' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeData.title) }} />
        <div className='storeContainer_body' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeData.body) }} />
        <div className='flex' style={{ justifyContent: storeData.alignment }}>
          <CTAButton ctaText={storeData.ctaText} onClick={() => goToCustomUrl(storeData.ctaUrl)} />
        </div>
      </div>
    </div>
  );
}

StoreBanner.propTypes = {
  data: PropTypes.shape({
    enabled: PropTypes.bool,
    order: PropTypes.number,
    imageUrl: PropTypes.string,
    mobileImageUrl: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    alignment: PropTypes.string,
  }),
};
